import Moment from 'moment';
import { extendMoment } from 'moment-range';
import parseFormat from 'moment-parseformat';

const moment = extendMoment(Moment);

export function parseDate(date) {
  return moment(date, parseFormat(date));
}

export function dateString(startDate, endDate, parseDates=true) {
  let dateString = '';
  if (startDate) {
    let momentStartDate;
    if (moment.isMoment(startDate)) {
      momentStartDate = startDate;
    } else {
      momentStartDate = parseDate(startDate);
    }

    if (parseDates && momentStartDate.isValid()) {
      dateString = `${momentStartDate.format('DDMMM').toUpperCase()}`;
    } else {
      dateString = startDate;
    }

    if (endDate) {
      let momentEndDate;
      if (moment.isMoment(endDate)) {
        momentEndDate = endDate;
      } else {
        momentEndDate = parseDate(endDate);
      }

      if (parseDates && momentStartDate.isValid() && momentEndDate.isValid()) {
        const duration = moment.range(
          momentStartDate, momentEndDate).diff('days');

        dateString = `${dateString}-${duration}NT`;
      } else {
        dateString = `${dateString}-${endDate}`;
      }
    }
  }

  return dateString;
}



// WEBPACK FOOTER //
// /src/util/dates.js